import { ref } from 'vue';

import { message } from 'ant-design-vue';

import { useRouter } from 'vue-router';

import { useI18n } from 'vue-i18n';

import { showErrorMessage } from '@/components/common/errorMessage';

import Api from '@/api/Api';
import { ACTION_CHANGE } from '@/components/tariffs/Consts';

export function useTariffUpdateApi(tariff, addDays, roverIds, action) {
	const { t } = useI18n();
	const router = useRouter();
	const isSubmitting = ref(false);
	const onApplyTariff = () => {
		if (action.value === ACTION_CHANGE && tariff.value == null) {
			return;
		}
		if (addDays.value == null || roverIds.value == null || roverIds.value.length === 0) {
			return;
		}
		isSubmitting.value = true;
		const handler = response => {
			if (response.status === 'ok') {
				if (response.with_payment) {
					message.info(t('tariffs.applyTariffModal.redirectingMessage'));
					window.location = response.confirmation_url;
				} else {
					message.success(t('tariffs.applyTariffModal.successMessage'));
					router.push({ name: 'rovers' });
				}
			} else {
				isSubmitting.value = false;
				showErrorMessage(response.errors);
			}
		}
		if (action.value === ACTION_CHANGE) {
			Api.tariffChange(tariff.value, addDays.value, roverIds.value, handler);
		} else {
			Api.tariffExtend(addDays.value, roverIds.value, handler);
		}
	};
	return {
		isSubmitting,
		onApplyTariff,
	};
}
